import { render, staticRenderFns } from "./PoliceverificationList.vue?vue&type=template&id=277a9200&scoped=true&"
import script from "./PoliceverificationList.vue?vue&type=script&lang=js&"
export * from "./PoliceverificationList.vue?vue&type=script&lang=js&"
import style0 from "./PoliceverificationList.vue?vue&type=style&index=0&id=277a9200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277a9200",
  null
  
)

export default component.exports